import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Mail, Phone, Trash2 } from "lucide-react";

export default function AdminContatti() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/contacts").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/contacts/${id}?new_status=${status}`);
    toast.success("Stato aggiornato");
    load();
  };
  const del = async (id) => {
    if (!confirm("Eliminare la richiesta?")) return;
    await api.delete(`/admin/contacts/${id}`);
    load();
  };

  const statusColor = { new: "bg-[var(--gold)]/20 text-[var(--gold)]", read: "bg-blue-500/20 text-blue-300", closed: "bg-white/10 text-white/60" };

  return (
    <div data-testid="admin-contatti" className="p-10">
      <h1 className="font-serif text-4xl text-white mb-2">Richieste Contatto</h1>
      <p className="text-white/50 text-sm mb-10">Gestisci le richieste ricevute dal modulo contatti.</p>

      <div className="space-y-4">
        {list.map((c) => (
          <div key={c.id} className="luxe-card p-6">
            <div className="flex flex-wrap justify-between items-start gap-4 mb-3">
              <div>
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="font-serif text-lg text-white">{c.name}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-sm ${statusColor[c.status] || statusColor.new}`}>{c.status}</span>
                  <span className="text-xs text-[var(--gold-soft)] uppercase tracking-wider">{c.type}</span>
                </div>
                <div className="flex gap-4 mt-2 text-sm text-white/60">
                  <span className="flex items-center gap-1"><Mail size={12} /> {c.email}</span>
                  {c.phone && <span className="flex items-center gap-1"><Phone size={12} /> {c.phone}</span>}
                </div>
              </div>
              <div className="text-xs text-white/40">{new Date(c.created_at).toLocaleString("it-IT")}</div>
            </div>
            <p className="text-sm text-white/80 mb-4 whitespace-pre-wrap">{c.message}</p>
            <div className="flex gap-2 flex-wrap">
              {c.status !== "read" && <button onClick={() => updateStatus(c.id, "read")} className="text-xs px-3 py-1.5 border border-white/15 text-white/70 hover:border-[var(--gold)]">Segna letta</button>}
              {c.status !== "closed" && <button onClick={() => updateStatus(c.id, "closed")} className="text-xs px-3 py-1.5 border border-white/15 text-white/70 hover:border-[var(--gold)]">Chiudi</button>}
              <button data-testid={`contact-delete-${c.id}`} onClick={() => del(c.id)} className="text-xs px-3 py-1.5 border border-red-500/30 text-red-400 hover:bg-red-500/10 flex items-center gap-1"><Trash2 size={12} /> Elimina</button>
            </div>
          </div>
        ))}
        {!list.length && <div className="text-white/40">Nessuna richiesta ancora.</div>}
      </div>
    </div>
  );
}
